import React from "react";
import ManagerDashboard from "views/admin/dashboard";
import UsersManagement from "views/admin/users-management";
import ClassMgmtView from "views/admin/classes-mgmt";
import SessionHub from "views/admin/sessions";
import UserSessions from "views/admin/user-sessions";
import StaffAttendance from "views/admin/participants/StaffAttendance";
import ProfileSettings from "views/admin/settings";
import ChangePassword from "views/user/settings/ChangePassword";
import SessionReportsBoard from "views/admin/reports/SessionReportsBoard";
import RevenueManagement from "views/admin/revenue";
import SendNotificationPage from "views/admin/notifications";
import CenterSettings from "views/admin/center-settings";
import LeaveRequestsPage from "views/admin/leave-requests";
import {
  MdOutlineAssignment,
  MdOutlineAttachMoney,
  MdOutlineBusiness,
  MdOutlineCalendarMonth,
  MdOutlineClass,
  MdOutlineEventBusy,
  MdOutlineFactCheck,
  MdOutlineGroups,
  MdOutlineLock,
  MdOutlineManageSearch,
  MdOutlineNotifications,
  MdOutlineSettings,
  MdOutlineSpaceDashboard,
} from "react-icons/md";

const dashboardRoute = {
  name: "nav.dashboard",
  layout: "/admin",
  path: "dashboard",
  icon: <MdOutlineSpaceDashboard className="h-6 w-6" />,
  component: <ManagerDashboard />,
};

const classRoutes = [
  {
    name: "nav.classesMgmt",
    layout: "/admin",
    path: "classes-mgmt/*",
    icon: <MdOutlineClass className="h-6 w-6" />,
    component: <ClassMgmtView />,
  },
  {
    name: "nav.sessions",
    layout: "/admin",
    path: "sessions",
    icon: <MdOutlineCalendarMonth className="h-6 w-6" />,
    component: <SessionHub />,
  },
  {
    name: "nav.userSessions",
    layout: "/admin",
    path: "user-sessions",
    icon: <MdOutlineManageSearch className="h-6 w-6" />,
    component: <UserSessions />,
  },
  {
    name: "nav.settings",
    layout: "/admin",
    path: "profile",
    icon: <MdOutlineSettings className="h-6 w-6" />,
    component: <ProfileSettings />,
  },
  {
    name: "nav.changePassword",
    layout: "/admin",
    path: "change-password",
    icon: <MdOutlineLock className="h-6 w-6" />,
    component: <ChangePassword />,
  },
];

const managerParticipantRoutes = [
  {
    name: "nav.staffAttendance",
    layout: "/admin",
    path: "staff-attendance",
    icon: <MdOutlineFactCheck className="h-6 w-6" />,
    component: <StaffAttendance />,
  },
];

const staffAttendanceRoute = {
  name: "nav.staffAttendance",
  layout: "/admin",
  path: "staff-attendance",
  icon: <MdOutlineFactCheck className="h-6 w-6" />,
  component: <StaffAttendance />,
};

const leaveRequestsRoute = {
  name: "nav.leaveRequests",
  layout: "/admin",
  path: "leave-requests",
  icon: <MdOutlineEventBusy className="h-6 w-6" />,
  component: <LeaveRequestsPage />,
};

const reportRoutes = [
  {
    name: "nav.reportTemplates",
    layout: "/admin",
    path: "report-templates",
    icon: <MdOutlineAssignment className="h-6 w-6" />,
    component: <SessionReportsBoard />,
  },
];

const revenueRoute = {
  name: "nav.revenue",
  layout: "/admin",
  path: "revenue",
  icon: <MdOutlineAttachMoney className="h-6 w-6" />,
  component: <RevenueManagement />,
  upcoming: true,
};

const notificationRoute = {
  name: "nav.sendNotification",
  layout: "/admin",
  path: "send-notifications",
  icon: <MdOutlineNotifications className="h-6 w-6" />,
  component: <SendNotificationPage />,
};

const centerSettingsRoute = {
  name: "nav.centerSettings",
  layout: "/admin",
  path: "center-settings",
  icon: <MdOutlineBusiness className="h-6 w-6" />,
  component: <CenterSettings />,
};

const managerExtraRoutes = [
  {
    name: "nav.staff",
    layout: "/admin",
    path: "users",
    icon: <MdOutlineGroups className="h-6 w-6" />,
    component: <UsersManagement />,
  },
];

export const getAdminRoutesByRole = (backendRole?: string) => {
  if (backendRole === "TEACHER") {
    return [
      ...classRoutes,
      staffAttendanceRoute,
      leaveRequestsRoute,
      ...reportRoutes,
      notificationRoute,
      ...managerExtraRoutes,
    ];
  }

  if (backendRole === "TRAINER") {
    return [...classRoutes, staffAttendanceRoute, ...reportRoutes];
  }

  if (backendRole === "MANAGER") {
    return [
      dashboardRoute,
      ...classRoutes,
      ...managerParticipantRoutes,
      leaveRequestsRoute,
      ...reportRoutes,
      notificationRoute,
      ...managerExtraRoutes,
      centerSettingsRoute,
      revenueRoute,
    ];
  }

  return [dashboardRoute, ...classRoutes, ...reportRoutes, ...managerExtraRoutes];
};

const adminRoutes = getAdminRoutesByRole();

export default adminRoutes;
